<template>
  <div class="wrap-form add-project-form">
    <el-form class="my-form" ref="form" label-position="left" :model="form" :rules="rules">
      <el-form-item label="项目标题" prop="title">
        <el-input type="text" placeholder="请输入项目标题" v-model="form.title" clearable></el-input>
      </el-form-item>
      <el-form-item label="项目团队" prop="project_depart_id">
        <el-dropdown @command="(e) => {form.project_depart_id = e}" trigger="click">
          <span class="el-dropdown-link" :class="{'content-box-show':form.project_depart_id ? true : false}">
            <span v-if="form.project_depart_id">{{form.project_depart_id && department.find(res => res.department_category_id === form.project_depart_id).name}}</span>
            <i class="icon iconfont iconicon_enlarge" v-else></i>
            <i class="icon iconfont iconicon_arrow_task"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="item in department" :key="item.department_category_id" :command="item.department_category_id" :label="item.name" :value="item.department_category_id">{{item.name}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-form-item>
      <el-form-item label="业务线" prop="project_list_id" label-width="70px" v-if="form.project_depart_id">
        <el-dropdown @command="(e) => {form.project_list_id = e}" trigger="click">
          <span class="el-dropdown-link" :class="{'content-box-show':form.project_list_id ? true : false}">
            <span v-if="form.project_list_id">{{form.project_list_id && projectFoderList.find(res => res.project_list_id === form.project_list_id).title}}</span>
            <i class="icon iconfont iconicon_enlarge" v-else></i>
            <i class="icon iconfont iconicon_arrow_task"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-show="item.active" v-for="item in projectFoderList" :key="item.project_list_id" :command="item.project_list_id" :label="item.title" :value="item.project_list_id">{{item.title}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-form-item>
      <el-form-item label="项目成员" prop="member">
        <div class="content-box-parent" :class="{'content-box-parent-show':memberList.length > 0 ? true : false}">
          <div class="content-box-item" v-if="memberList.length > 0">
            <Myavatar v-for="(item,index) in memberList" :key="item.uid" width="28px" height="28px" :imgUrl="item.user_avatar" :userName="item.name" v-show="index < 8"></Myavatar>
            <i v-if="memberList.length > 8" class="icon iconfont iconicon_user_more_task"></i>
          </div>
          <div class="content-box project-select-member">
            <el-popover placement="bottom" trigger="click" v-model="memberVisible">
              <span slot="reference">
                <i class="icon iconfont iconicon_enlarge"></i>
              </span>
              <ParticipantList @close="memberVisible = false" :selectedData="form.member" @confirm="slecetVaule" :taskMemberlist="options" :lockUid="[]"></ParticipantList>
            </el-popover>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="已添加的成员" class="newPipoe">
        <div>
          <div class="team-box">
            <div class="member-item" v-for="item in memberList" :key="item.userId">
              <div class="member-avatar" style="margin-left:6px;">
                <Myavatar width="28px" height="28px" :imgUrl="item.user_avatar" :userName="item.name">{{item.name}}</Myavatar>
              </div>
              <div class="member-icon"><i class="el-icon-close" @click="removeUser(item)"></i></div>
            </div>
            <span v-if="memberList.length === 0" style="color: rgba(58, 73, 96, 0.4);font-size:12px;margin-top:8px;">暂无</span>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <div class="submit-box">
      <wf-button type="primary" style="width: 120px;margin-right:30px;" @click="onSubmit" :disabled="!isDisabled">创建项目</wf-button>
    </div>
    <div class="close-form" @click="close"><i class="el-icon-close"></i></div>
  </div>
</template>
<script>
import api from "@/services/api/department/department.js"
import sysApi from "@/services/api/systemSetting/systemSetting.js"
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';
import ParticipantList from '@/views/customKeyPage/components/participant/participantList'
function createdCascaderData(sourceData) {
  return sourceData.map(item => {
    let temp = {}
    temp["uid"] = item.uid || item.depart_id
    temp["realname"] = item.name || item.realname
    if (item.member && item.member.length > 0) {
      temp["children"] = createdCascaderData(item.member)
    } else {
      temp["children"] = null
    }
    return temp
  })
}
// 平铺数据
function tileData(dataList) {
  let arr = [];
  dataList.forEach(item => {
    if(item.children && item.children.length > 0){
      arr = [...arr, ...item.children];
    }
  });
  return arr;
}
export default {
  name: "addProject",
  data() {
    return {
      form: {
        title: "", //项目标题
        member: [],
        project_depart_id: "",
        project_list_id: ""
      },
      rules: {
        title: [
          { required: true, trigger: "change", message: "项目标题不能为空" },
          { max: 140, trigger: "change", message: "项目标题不能超过140个字符" }
        ],
        project_depart_id: [{ required: true, trigger: "change", message: "项目团队不能为空" }],
        member: [{ required: true, trigger: "blur", message: "项目成员不能为空" }],
        project_list_id: [{ required: true, trigger: "change", message: "业务线不能为空" }]
      },
      memberList: [],
      defaultArr: [],
      options: [],
      department: [],
      departmentProjectFolderList: [],
      memberVisible: false,
      isDisabled: true
    };
  },
  components: {
    ParticipantList
  },
  computed: {
    projectFoderList() {
      let temp = [];
      temp = this.departmentProjectFolderList.filter((item) => {
        return item.department_category_id == this.form.project_depart_id
      })
      return temp[0] && temp[0].projectList || []
    }
  },
  watch: {
    form: {
      handler() {
        for (let key in this.form) {
          this.isDisabled = Array.isArray(this.form[key]) ? this.form[key].length > 0 : Boolean(this.form[key])
          console.log(this.isDisabled, this.form, key)
          if (!this.isDisabled) return
        }
      },
      deep: true,
      immediate: true
    }
  },
  created() {
  },
  mounted() {
    this.fetchDepartmentUser();
    this.fetchProjectFolderList();
  },
  methods: {
    ...mapActions('project/project', ['addProject', 'editProject',]),
    fetchDepartmentUser() {
      // 获取所有的部门员工信息
      api.getDepartmentUser({ working_status: '在职' }).then(res => {
        this.options = createdCascaderData(res.departmentgroup)
      });
    },
    fetchProjectFolderList() {
      sysApi.getDepartmentProjectFolderList().then(res => {
        this.departmentProjectFolderList = res;
        this.department = res.map((item) => {
          return {
            department_category_id: item.department_category_id,
            name: item.name
          }
        })
      })
    },
    resetForm() {
      this.form.title = "";
      this.form.project_depart_id = null;
      this.form.project_list_id = ""
      this.form.member = [];
      this.memberList = [];
      this.$refs['form'].resetFields();
      this.$refs["sle"].clearCheckedNodes(true);
    },
    onSubmit() {
      // 表单验证
      this.$refs.form.validate(valid => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.form))
          // params.member = params.member.map(res => res[res.length - 1])
          this.addProject(params).then(res => {
            this.$emit("success");
            this.resetForm();
          });
        }
      });
    },
    removeUser(itemData) {
      let index = this.memberList.indexOf(itemData);
      let idx = 0
      this.form.member.find((res, index) => {
        idx = index
        return itemData.userId == res[res.length - 1]
      })
      this.memberList.splice(index, 1);
      let arr = JSON.parse(JSON.stringify(this.form.member))
      arr.splice(idx, 1)
      this.form.member = [...arr]
    },
    selectChange(v1, v2) {
      // 这里更新用户列表
      this.$nextTick(() => {
        let checkedNode = this.$refs["sle"].getCheckedNodes(true);
        let arr = checkedNode.map(item => {
          return {
            userId: item.value,
            name: item.label,
            user_avatar: item.data.user_avatar
          };
        });
        this.memberList = [...arr]
      })
    },
    close() {
      this.$emit("update:visible", false)
    },
    slecetVaule(data) {
      this.memberVisible = false
      let checkNode = tileData(this.options)
      let arr = checkNode.map(item => {
        if (data.find(uid => uid === item.uid)) {
          return {
            userId: item.uid,
            name: item.realname,
            user_avatar: item.user_avatar
          }
        }
      }).filter(res => res)
      this.memberList = [...arr]
      this.form.member = JSON.parse(JSON.stringify(data))
    }
  }
};
</script>

<style lang="scss">
.add-project-form {
  padding: 10px;
  overflow: auto;
  height: 100%;
  .el-dropdown i{
    font-size: 16px;
  }
  .el-form-item__error {
    // margin-top: -7px;
  }
  .project-select-member {
    overflow: visible;
    height: 36px;
    width: 32px;
    flex-shrink: 0;
  }
  .submit-box {
    padding: 15px 0;
    display: flex;
    justify-content: flex-start;
  }
  .el-form--label-top .el-form-item__label {
    padding: 0;
  }
  .close-form {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 20px;
    height: 20px;
    font-size: 20px;
    cursor: pointer;
  }
  .newPipoe {
    display: flex;
    flex-direction: column;
  }
  .el-form-item {
    margin-bottom: 20px;
  }
  .el-form-item__content {
    line-height: 40px;
  }
  .el-dropdown-link {
    line-height: 40px;
  }
  .iconicon_user_more_task {
    display: flex;
    align-items: center;
  }
  .team-box {
    line-height: 1.3;
  }
}
</style>
